/**
 * Deep-link helpers for WalletConnect v2 on mobile browsers (coarse pointer).
 * Pattern aligned with ChargeAndStrike `useWalletAuth` WALLETCONNECT_MOBILE_WALLETS.
 */

export type WalletConnectMobileWalletOption = {
  id: string
  name: string
  /** Build app-specific WC bridge URL; if absent, caller may fall back to raw `wc:` URI. */
  getUri?: (wcUri: string) => string
}

export const WALLETCONNECT_MOBILE_WALLET_OPTIONS: WalletConnectMobileWalletOption[] = [
  {
    id: 'rainbow',
    name: 'Rainbow',
    getUri: (uri) =>
      `https://rnbwapp.com/wc?uri=${encodeURIComponent(uri)}&connector=rainbowkit`
  },
  {
    id: 'trust',
    name: 'Trust Wallet',
    getUri: (uri) => `trust://wc?uri=${encodeURIComponent(uri)}`
  },
  {
    id: 'coinbase',
    name: 'Coinbase Wallet',
    getUri: (uri) => `https://go.cb-w.com/wc?uri=${encodeURIComponent(uri)}`
  },
  {
    id: 'okx',
    name: 'OKX Wallet',
    getUri: (uri) => `okex://main/wc?uri=${encodeURIComponent(uri)}`
  },
  {
    id: 'walletConnect',
    name: 'WalletConnect'
  }
]

export function openWalletConnectMobileBridge(
  walletId: string,
  wcUri: string,
  options: WalletConnectMobileWalletOption[] = WALLETCONNECT_MOBILE_WALLET_OPTIONS
): void {
  if (typeof window === 'undefined') return
  const selected = options.find((w) => w.id === walletId)
  const target = selected?.getUri ? selected.getUri(wcUri) : wcUri
  window.location.assign(target)
}

/**
 * True when we prefer the mobile “open wallet app” list over a large desktop QR (Charge & Strike uses `(pointer: coarse)`).
 */
export function preferWalletConnectMobileBridge(): boolean {
  if (typeof window === 'undefined') return false
  try {
    return window.matchMedia('(pointer: coarse)').matches
  } catch {
    return false
  }
}
